import React from "react";

class Contact extends React.Component {
  state = {
    name: "",
    email: "",
    message: ""
  }

  handleInputChange = event => {
    const { name, value } = event.target;
    this.setState({
      [name]: value
    });
  };

  render() {
    return (
      <div className="container contact-container" style={{backgroundColor: 'white'}}>
        <h1 style={{textAlign: 'center'}}>Contact Me</h1>
        <div className="row">
          <form className="col s12" action="https://formspree.io/dwilli77@gmail.com" method="POST" style={{marginBottom:15}}>
            <div className="row">
              <div className="input-field col s6">
                <i className="material-icons prefix">person_outline</i>
                <input value={this.state.name} name="name" id="contact_name" type="text" className="validate" onChange={this.handleInputChange} />
                <label htmlFor="contact_name">Name</label>
              </div>
            </div>
            <div className="row">
              <div className="input-field col s6">
                <i className="material-icons prefix">email</i>
                <input value={this.state.email} name="email" id="contact_email" type="email" className="validate" onChange={this.handleInputChange} />
                <label htmlFor="contact_email">Email</label>
              </div>
            </div>
            <div className="row">
              <div className="col s10">
                <div className="row">
                  <div className="input-field col s12">
                    <i className="material-icons prefix">mode_edit</i>
                    <textarea value={this.state.message} name="message" id="contact_textarea" className="materialize-textarea" onChange={this.handleInputChange} />
                    <label htmlFor="contact_textarea">Message</label>
                  </div>
                </div>
              </div>
            </div>
            <div className="center-align">
            <button className="btn-large waves-effect waves-light" type="submit">Submit
              <i className="material-icons right">send</i>
            </button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default Contact;
